module.exports = __webpack_public_path__ + "media/images/labs-click-3b886ab43b8e9e0e4b3b262eaa3081f4.png";